import { StorageService } from 'src/app/services/storage.service';
import { Component, Input, OnInit } from '@angular/core';
import { Menu } from 'src/app/interfaces/global.interface';
import { ActivatedRoute, Router } from '@angular/router';
import {UserTypesEnum} from "../../../enums/user-types.enum";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  @Input() sidebarMenu: Menu;
  menuData: Menu;
  currentMenu: any;
  userType: string;
  profile: any;
  homeLink: string;
  imageUrl = '../../../../../assets/images/emblem.png';

  activeRoute: string;

  constructor(private storage: StorageService, private route: Router) {}

  ngOnInit(): void {

    this.menuData = this.sidebarMenu;
    this.userType = this.storage.getItem('userType');
    //check the profile of user
    this.profile = this.storage.getItem('profile');

    if (this.profile?.profileType !== UserTypesEnum.Executive) {
      this.homeLink = '/tgsd-landing';
    } else {
      this.homeLink = '/reports';
    }
  }

  isNavigated(navLink: string, isParent: boolean = true) {
    return this.route.url.includes(navLink);
  }
}
